module.exports = __webpack_public_path__ + "static/media/cert_119.b19f0c30.jpg";